module.exports = __webpack_public_path__ + "static/media/email.bb5cc6f3.svg";